<template>
  <div style="position: relative;">
    <el-form ref="QueryJobTitleFilter" :model="QueryJobTitle" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="职称名称" prop="formFilter.jobTitleName">
          <el-input class="filter-item" v-model="QueryJobTitle.formFilter.jobTitleName"
                    :clearable="true" placeholder="职称名称"
          />
        </el-form-item>
        <el-form-item label="所属部门" prop="formFilter.sysDeptId">
          <el-cascader class="input-item" v-model="QueryJobTitle.formFilter.sysDeptId" :clearable="true" filterable
                       placeholder="所属部门" :loading="QueryJobTitle.sysDeptId.impl.loading" :props="{value: 'deptId', label: 'deptName', checkStrictly: true}"
                       @visible-change="QueryJobTitle.sysDeptId.impl.onVisibleChange" :options="QueryJobTitle.sysDeptId.impl.dropdownList"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="登录账号" prop="formFilter.loginName">
          <el-input class="filter-item" v-model="QueryJobTitle.formFilter.loginName"
                    :clearable="true" placeholder="登录账号"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.showName">
          <el-input class="filter-item" v-model="QueryJobTitle.formFilter.showName"
                    :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetQueryJobTitle">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshQueryJobTitle(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="QueryJobTitle" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>职称列表</span>
              <div class="base-card-operation">
                <!--
                <el-button @click="onAddJobTitleClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('JobTitleManage:QueryJobTitle:AddJobTitle') || !addJobTitleEnabled">
                  添加
                </el-button>
                -->
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paJobTitle" :data="QueryJobTitle.PaJobTitle.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryJobTitle.PaJobTitle.impl.onSortChange"
                          header-cell-class-name="table-header-gray"
                          highlight-current-row @current-change="QueryJobTitle.PaJobTitle.impl.currentRowChange"
                          @row-click="handleRowClick" row-key="id" default-expand-all height="550px"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryJobTitle.PaJobTitle.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name" width="200px">
                  </el-table-column>
                  <el-table-column label="级别" prop="levelCodeDictMap.name">
                  </el-table-column>
                  <el-table-column label="津贴" prop="allowance">
                  </el-table-column>
                  <el-table-column label="描述" prop="detail">
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right" width="120px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('JobTitleManage:QueryJobTitle:delete')">
                        删除
                      </el-button>
                      <el-button @click.stop="onEditJobTitleClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('JobTitleManage:QueryJobTitle:EditJobTitle')">
                        编辑
                      </el-button>
                      <el-button @click.stop="onAddJobTitleClick(scope.row)" type="text" :size="defaultFormItemSize" v-show="scope.row.type==='group'&&scope.row.id!==0"
                                 :disabled="!checkPermCodeExist('JobTitleManage:QueryJobTitle:AddJobTitle') || !addJobTitleEnabled">
                        添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="12" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>员工列表</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="sysUser" :data="QueryJobTitle.SysUser.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryJobTitle.SysUser.impl.onSortChange"
                          header-cell-class-name="table-header-gray" height="550px"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryJobTitle.SysUser.impl.getTableIndex" />
                  <el-table-column label="登录账号" prop="loginName">
                  </el-table-column>
                  <el-table-column label="姓名" prop="showName">
                  </el-table-column>
                  <el-table-column label="所属部门" prop="deptIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职位状态" prop="jobStatusDictMap.name">
                  </el-table-column>
                  <el-table-column label="工龄" prop="workYears">
                  </el-table-column>
                  <el-table-column label="薪级" prop="jobLevelIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职称" prop="jobTitleIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="性别" prop="genderDictMap.name">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onEditUserInfoClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('JobTitleManage:QueryJobTitle:EditUserInfo')">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {PaJobTitleController, SysUserController, DictionaryController, SysDeptController} from '@/api';
import addJobTitle from '@/views/JobTitle/addJobTitle.vue';
import editJobTitle from '@/views/JobTitle/editJobTitle.vue';

export default {
  name: 'JobTitleManage',
  props: {
    name: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      selectedRow: {},
      formData: {
        PaJobTitle: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          levelCode: undefined,
          detail: undefined,
          allowance: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sort: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      },
      QueryJobTitle: {
        formFilter: {
          jobTitleName: undefined,
          sysDeptId: undefined,
          loginName: undefined,
          showName: undefined
        },
        formFilterCopy: {
          jobTitleName: undefined,
          sysDeptId: undefined,
          loginName: undefined,
          showName: undefined
        },
        PaJobTitle: {
          impl: new TableWidget(this.loadPaJobTitleWidgetData, this.loadPaJobTitleVerify, false, true, 'sort', 1)
        },
        SysUser: {
          impl: new TableWidget(this.loadSysUserWidgetData, this.loadSysUserVerify, false, false, 'showName', 1)
        },
        sysDeptId: {
          impl: new DropdownWidget(this.loadSysDeptIdDropdownList, true, 'deptId')
        },
        JobTitleDev: {
          isInit: false
        },
        UserInfoDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paJobTitle.clearSelection();
      }
      this.$refs.paJobTitle.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetQueryJobTitle () {
      this.$refs.QueryJobTitleFilter.resetFields();
      this.refreshQueryJobTitle(true);
    },
    /**
     * 职称列表数据获取函数，返回Promise
     */
    loadPaJobTitleWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paJobTitleDtoFilter: {
          name: this.QueryJobTitle.formFilterCopy.jobTitleName,
          searchString: this.name
        },
        sysUserDtoFilter: {
          deptTid: this.QueryJobTitle.formFilterCopy.sysDeptId
        }
      }
      return new Promise((resolve, reject) => {
        PaJobTitleController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].type !== 'title') {
              dataList[i].levelCodeDictMap.name = '';
              dataList[i].allowance = undefined;
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.QueryJobTitle.PaJobTitle.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.QueryJobTitle.PaJobTitle.impl.currentRow.id, 'id');
              this.$refs.paJobTitle.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职称列表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaJobTitleVerify () {
      this.QueryJobTitle.formFilterCopy.sysDeptId = this.QueryJobTitle.formFilter.sysDeptId;
      this.QueryJobTitle.formFilterCopy.jobTitleName = this.QueryJobTitle.formFilter.jobTitleName;
      return true;
    },
    /**
     * 用户管理数据获取函数，返回Promise
     */
    loadSysUserWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysUserDtoFilter: {
          loginName: this.QueryJobTitle.formFilterCopy.loginName,
          deptTid: this.QueryJobTitle.formFilterCopy.sysDeptId,
          showName: this.QueryJobTitle.formFilterCopy.showName,
          jobTitleId: (this.QueryJobTitle.PaJobTitle.impl.currentRow || {}).id
        }
      }
      return new Promise((resolve, reject) => {
        SysUserController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 用户管理数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.QueryJobTitle.formFilterCopy.loginName = this.QueryJobTitle.formFilter.loginName;
      this.QueryJobTitle.formFilterCopy.sysDeptId = this.QueryJobTitle.formFilter.sysDeptId;
      this.QueryJobTitle.formFilterCopy.showName = this.QueryJobTitle.formFilter.showName;
      return true;
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadSysDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 更新职称列表
     */
    refreshJobTitleDevWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryJobTitle.PaJobTitle.impl.refreshTable(true, 1);
      } else {
        this.QueryJobTitle.PaJobTitle.impl.refreshTable();
      }
      this.QueryJobTitle.JobTitleDev.isInit = true;
    },
    /**
     * 更新员工列表
     */
    refreshUserInfoDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryJobTitle.SysUser.impl.refreshTable(true, 1);
      } else {
        this.QueryJobTitle.SysUser.impl.refreshTable();
      }
      this.QueryJobTitle.UserInfoDiv.isInit = true;
    },
    /**
     * 更新职称管理
     */
    refreshQueryJobTitle (reloadData = false) {
      if (reloadData) {
        this.QueryJobTitle.PaJobTitle.impl.refreshTable(true, 1);
      } else {
        this.QueryJobTitle.PaJobTitle.impl.refreshTable();
      }
      if (reloadData) {
        this.QueryJobTitle.SysUser.impl.refreshTable(true, 1);
      } else {
        this.QueryJobTitle.SysUser.impl.refreshTable();
      }
      if (!this.QueryJobTitle.isInit) {
      }
      this.QueryJobTitle.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      if (row.pid === -1) {
        this.$message.error('删除失败!节点不能删除!');
        return;
      }
      if (row.children !== undefined && row.children.length > 0) {
        this.$message.error('删除失败!请先删除子项!');
        return;
      }

      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaJobTitleController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.QueryJobTitle.PaJobTitle.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddJobTitleClick (row) {
      row = (row || this.QueryJobTitle.PaJobTitle.impl.currentRow || {});
      if (row.type !== 'group') {
        this.$message.error('添加失败!不能添加子节点!');
        return;
      }
      let type = (row.pid === -1) ? 'group' : 'title';
      let params = {
        pid: row.id,
        type: type
      };
      let title = '添加';
      if (params.type === 'group') {
        title = '添加组';
      }
      this.$dialog.show(title, addJobTitle, {
        area: '400px'
      }, params).then(res => {
        this.refreshJobTitleDevWidget();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditJobTitleClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', editJobTitle, {
        area: '400px'
      }, params).then(res => {
        this.QueryJobTitle.PaJobTitle.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditUserInfoClick (row) {
      let params = {
        userId: row.userId
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditUserInfo', query: params});
    },
    onResume () {
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaJobTitle: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          levelCode: undefined,
          detail: undefined,
          allowance: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sort: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshQueryJobTitle();
    }
  },
  computed: {
    addJobTitleEnabled () {
      return this.QueryJobTitle.PaJobTitle.impl.currentRow != null;
    },
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
    // 职称列表选择行数据变化
    'QueryJobTitle.PaJobTitle.impl.currentRow': {
      handler (newValue) {
        this.QueryJobTitle.SysUser.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
